"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useRatesContext = exports.RatesProvider = void 0;
var _react = require("react");
var _constate = _interopRequireDefault(require("constate"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// 1️⃣ Create a custom hook as usual
function useRates() {
  const [state, setState] = (0, _react.useState)({
    type: "",
    purchasePrice: "",
    downPaymentInUSDs: "",
    downPaymentInPercents: "",
    CreditScore: "",
    ShowButtons: true,
    propertyType: "",
    propertyUse: "",
    lowRates: undefined,
    lowRatesOption: undefined,
    estimatedValue: "",
    loanBalance: "",
    loanAmount: "",
    estimatedHomeValue: "",
    cashoutAmount: "",
    zipCode: "",
    countryState: "Select a State",
    stateCounty: "",
    stateCountyName: "",
    veteran: "",
    stateList: ""
  });
  const TypeSelected = payload => {
    setState(_objectSpread(_objectSpread({}, state), {}, {
      type: payload
    }));
  };
  const PurchasePriceUpdate = payload => {
    setState(_objectSpread(_objectSpread({}, state), {}, {
      purchasePrice: payload
    }));
  };
  const DownPaymentInUSDsUpdate = payload => {
    setState(_objectSpread(_objectSpread({}, state), {}, {
      downPaymentInUSDs: payload
    }));
  };
  const DownPaymentInPercentsUpdate = payload => {
    setState(_objectSpread(_objectSpread({}, state), {}, {
      downPaymentInPercents: payload
    }));
  };
  const CreditScoreUpdate = payload => {
    setState(_objectSpread(_objectSpread({}, state), {}, {
      CreditScore: payload
    }));
  };
  const ShowButtons = payload => {
    setState(_objectSpread(_objectSpread({}, state), {}, {
      ShowButtons: payload
    }));
  };
  const propertyTypeUpdate = payload => {
    setState(_objectSpread(_objectSpread({}, state), {}, {
      propertyType: payload
    }));
  };
  const propertyUsedUpdate = payload => {
    setState(_objectSpread(_objectSpread({}, state), {}, {
      propertyUse: payload
    }));
  };
  const lowRatesUpdate = payload => {
    setState(_objectSpread(_objectSpread({}, state), {}, {
      lowRates: payload
    }));
  };
  const lowRatesOptionUpdate = payload => {
    setState(_objectSpread(_objectSpread({}, state), {}, {
      lowRatesOption: payload
    }));
  };
  const estimatedValueUpdate = payload => {
    setState(_objectSpread(_objectSpread({}, state), {}, {
      estimatedValue: payload
    }));
  };
  const loanBalanceUpdate = payload => {
    setState(_objectSpread(_objectSpread({}, state), {}, {
      loanBalance: payload
    }));
  };
  const cashoutAmountUpdate = payload => {
    setState(_objectSpread(_objectSpread({}, state), {}, {
      cashoutAmount: payload
    }));
  };
  const estimatedHomeValueUpdate = payload => {
    setState(_objectSpread(_objectSpread({}, state), {}, {
      estimatedHomeValue: payload
    }));
  };
  const loanAmountTotalUpdate = payload => {
    setState(_objectSpread(_objectSpread({}, state), {}, {
      loanAmount: payload
    }));
  };
  const zipCodeUpdate = payload => {
    setState(_objectSpread(_objectSpread({}, state), {}, {
      zipCode: payload
    }));
  };
  const countryStateUpdate = payload => {
    setState(_objectSpread(_objectSpread({}, state), {}, {
      countryState: payload
    }));
  };
  const stateCountyUpdate = payload => {
    setState(_objectSpread(_objectSpread({}, state), {}, {
      stateCounty: payload
    }));
  };
  const stateCountyNameUpdate = payload => {
    setState(_objectSpread(_objectSpread({}, state), {}, {
      stateCountyName: payload
    }));
  };
  const veteranUpdate = payload => {
    setState(_objectSpread(_objectSpread({}, state), {}, {
      veteran: payload
    }));
  };
  const stateListUpdate = payload => {
    setState(_objectSpread(_objectSpread({}, state), {}, {
      stateList: payload
    }));
  };
  return {
    state,
    TypeSelected,
    PurchasePriceUpdate,
    DownPaymentInUSDsUpdate,
    DownPaymentInPercentsUpdate,
    CreditScoreUpdate,
    ShowButtons,
    propertyTypeUpdate,
    propertyUsedUpdate,
    lowRatesUpdate,
    lowRatesOptionUpdate,
    estimatedValueUpdate,
    loanBalanceUpdate,
    cashoutAmountUpdate,
    estimatedHomeValueUpdate,
    loanAmountTotalUpdate,
    zipCodeUpdate,
    countryStateUpdate,
    stateCountyUpdate,
    stateCountyNameUpdate,
    veteranUpdate,
    stateListUpdate
  };
}

// 2️⃣ Wrap your hook with the constate factory
const [RatesProvider, useRatesContext] = (0, _constate.default)(useRates);
exports.useRatesContext = useRatesContext;
exports.RatesProvider = RatesProvider;